import { Component, OnInit } from '@angular/core';
import { IncomeVsExpenseHandler } from './incomeVsExpense.handler.';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { Router } from '@angular/router';
import { OfflineService } from 'src/app/offline/offline.service';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'sym-dashboard4',
  templateUrl: './incomeVsExpense.component.html',
  styleUrls: ['./incomeVsExpense.component.scss'],
})
export class IncomeVsExpenseComponent extends IncomeVsExpenseHandler implements OnInit {
  constructor(
    public service: DashboardService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(service, headerService, router, settingService, offlineService);
  }
}
